/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Admin_Smbody1Inputs */

const zh_landing_admin_smbody1 = /** @type {(inputs: Landing_Admin_Smbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上传笔记、幻灯片、PDF 或录音，StudyOS 会立即把它们转化为结构化的摘要、测验和闪卡。再也不用重新整理笔记或手动制作学习内容。`)
};

const en_landing_admin_smbody1 = /** @type {(inputs: Landing_Admin_Smbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload notes, slides, PDFs, or recordings — StudyOS instantly transforms them into structured summaries, quizzes, and flashcards. No more rewriting notes or manually creating study content.`)
};

const es_landing_admin_smbody1 = /** @type {(inputs: Landing_Admin_Smbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sube apuntes, diapositivas, PDF o grabaciones: StudyOS los transforma al instante en resúmenes estructurados, cuestionarios y tarjetas. Adiós a reescribir apuntes o crear contenido a mano.`)
};

/**
* | output |
* | --- |
* | "Upload notes, slides, PDFs, or recordings — StudyOS instantly transforms them into structured summaries, quizzes, and flashcards. No more rewriting notes or ..." |
*
* @param {Landing_Admin_Smbody1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const landing_admin_smbody1 = /** @type {((inputs?: Landing_Admin_Smbody1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Admin_Smbody1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_admin_smbody1(inputs)
	if (locale === "en") return en_landing_admin_smbody1(inputs)
	return es_landing_admin_smbody1(inputs)
});
export { landing_admin_smbody1 as "landing_admin_smBody" }